import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=45bcc3fe&"
import script from "./Sport.vue?vue&type=script&lang=ts&"
export * from "./Sport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports